import { TextField, TextFieldProps } from '@mui/material';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import React, { ReactElement } from 'react';
import { InputBaseProps } from '@mui/material/InputBase';
import { is } from '../../utils';

interface Props {
  size?: 'small' | 'medium';
  inputProps?: InputBaseProps['inputProps'];
  textFieldProps?: TextFieldProps;
}

export function GtDatePicker<TInputDate>({
  onChange,
  size,
  inputProps,
  textFieldProps = {},
  ...props
}: Omit<DatePickerProps<TInputDate, Date>, 'renderInput'> &
  Props): ReactElement {
  return (
    <DatePicker
      {...props}
      inputFormat="DD.MM.YYYY"
      mask="__.__.____"
      onChange={(value: Date | null, keyboardInputValue?: string) => {
        if (value === null) {
          onChange(null, keyboardInputValue);
          return;
        }

        const date = new Date(value);

        if (
          !is.validDate(date) ||
          date.getFullYear() < 1900 ||
          date.getFullYear() > 2050
        ) {
          return;
        }

        onChange(date, keyboardInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="dd.mm.yyyy"
          InputLabelProps={{
            shrink: true,
          }}
          size={size}
          inputProps={{
            ...(params.inputProps || {}),
            ...(inputProps || {}),
          }}
          error={false}
          variant="outlined"
          fullWidth
          disabled={props.disabled}
          {...textFieldProps}
        />
      )}
    />
  );
}
